import {useCurrentBasket} from '../../../hooks/use-current-basket'
import {useEffect, useState} from 'react'
import {trackViewCart} from '../../../tracking/analytics'
import useProductItemsDetail from '../../../hooks/useProductItemsDetail'

const useTrackViewCart = () => {
    const {data: basket} = useCurrentBasket()
    const {data: productItemsDetail, isLoading: isProductItemsDetailLoading} =
        useProductItemsDetail(basket)
    const [tracked, setTracked] = useState(false)

    useEffect(() => {
        // only track once
        if (tracked) {
            return
        }
        // only track if basket has currency
        if (!basket?.currency) {
            return
        }

        // only track if product items detail are loaded
        if (isProductItemsDetailLoading) {
            return
        }

        // track cart
        trackViewCart(basket, productItemsDetail)
        // set tracked
        setTracked(true)
    }, [tracked, basket, productItemsDetail, isProductItemsDetailLoading])
}

export default useTrackViewCart
